import React, { createContext, useContext, useState } from "react";

const AppContext = createContext(null);

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
};

const INITIAL_LINKED_NUMS = [
  { op: "o", num: "699 XXX XXX", def: true },
  { op: "m", num: "677 XXX XXX", def: false },
];

const INITIAL_TX_DATA = [
  { type: "credit", payPhone: "699 XXX 123", recPhone: "655 XXX 456", date: "14 mars", time: "09:41", amount: -1000, label: "Crédit Orange" },
  { type: "transfer", payPhone: "699 XXX 789", recPhone: "677 XXX 012", date: "12 mars", time: "14:23", amount: -5000, label: "Transfert OM→MTN" },
  { type: "receive", payPhone: "Rechargement", recPhone: "699 XXX 789", date: "10 mars", time: "08:15", amount: 20000, label: "Rechargement OM" },
  { type: "credit", payPhone: "677 XXX 789", recPhone: "655 XXX 012", date: "9 mars", time: "17:05", amount: -2000, label: "Crédit MTN" },
  { type: "transfer", payPhone: "677 XXX 345", recPhone: "699 XXX 678", date: "7 mars", time: "11:30", amount: -10000, label: "Transfert MTN→OM" },
  { type: "receive", payPhone: "Virement reçu", recPhone: "677 XXX 789", date: "5 mars", time: "16:48", amount: 15000, label: "Reçu MTN MoMo" },
  { type: "credit", payPhone: "699 XXX 123", recPhone: "655 XXX 901", date: "3 mars", time: "10:12", amount: -500, label: "Crédit Orange" },
  { type: "transfer", payPhone: "699 XXX 789", recPhone: "677 XXX 234", date: "1 mars", time: "19:22", amount: -8000, label: "Transfert OM→MTN" },
];

export function AppProvider({ children }) {
  const [linkedNums, setLinkedNums] = useState(INITIAL_LINKED_NUMS);
  const [transactions, setTransactions] = useState(INITIAL_TX_DATA);

  // État de confirmation de transaction (partagé entre pages)
  const [pendingTx, setPendingTx] = useState(null);

  const addLinkedNum = (op, num) => {
    setLinkedNums((prev) => [...prev, { op, num, def: false }]);
  };

  const removeLinkedNum = (index) => {
    setLinkedNums((prev) => prev.filter((_, i) => i !== index));
  };

  const setDefaultNum = (index) => {
    setLinkedNums((prev) => prev.map((n, i) => ({ ...n, def: i === index })));
  };

  const addTransaction = (tx) => {
    setTransactions((prev) => [tx, ...prev]);
  };

  return (
    <AppContext.Provider
      value={{
        linkedNums,
        addLinkedNum,
        removeLinkedNum,
        setDefaultNum,
        transactions,
        addTransaction,
        pendingTx,
        setPendingTx,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
